import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button, DialogTitle } from '@material-ui/core';
import { ReactComponent as CloseIcon } from 'common-assets/assets/icons/close.svg';
import { DialogCloseButtonProps } from './DialogCloseButton.model';

import useStyles from './DialogCloseButton.style';

export const DialogCloseButton = ({
  onClick,
}: DialogCloseButtonProps) => {
  const c = useStyles({});
  const [tt] = useTranslation();

  return (
    <DialogTitle className={c.closeButtonWrapper} disableTypography>
      <Button onClick={onClick} className={c.button} aria-label={tt('close-dialog')}>
        <CloseIcon data-testid="close-icon" aria-hidden="true" focusable={false} />
      </Button>
    </DialogTitle>
  );
};

